'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var themeUtils = require('./themeUtils-2eefcd1f.js');
require('./enums-de2d9d36.js');
var tab = require('./tab-7d963d53.js');
var line = require('./line-6e9b6071.js');

var StyledTabs = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction:  ", ";\n  ", ";\n"], ["\n  display: flex;\n  flex-direction:  ", ";\n  ", ";\n"])), function (_a) {
    var orientation = _a.orientation;
    return (orientation === 'vertical' ? 'column' : 'row');
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'icon' && 'width: fit-content');
});
var TabsContainer = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var Tabs = function (_a) {
    var activeTab = _a.activeTab, data = _a.data, children = _a.children, theme = _a.theme, onChange = _a.onChange, _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, _c = _a.variant, variant = _c === void 0 ? 'inline' : _c, _d = _a.lineWidth, lineWidth = _d === void 0 ? 2 : _d, className = _a.className, 
    // 120 - standard tab width in all our mocks
    _e = _a.tabSize, 
    // 120 - standard tab width in all our mocks
    tabSize = _e === void 0 ? orientation === 'horizontal' ? 120 : 24 : _e, 
    // 36 - default margin for vertical tabs
    _f = _a.verticalTabBottomMargin, 
    // 36 - default margin for vertical tabs
    verticalTabBottomMargin = _f === void 0 ? 36 : _f, restTabsProps = tslib_es6.__rest(_a, ["activeTab", "data", "children", "theme", "onChange", "orientation", "variant", "lineWidth", "className", "tabSize", "verticalTabBottomMargin"]);
    // TODO remove internal state as it makes the component uncontrollable
    var _g = tslib_es6.__read(React.useState(activeTab || 0), 2), active = _g[0], setActiveTab = _g[1];
    var handleClick = React.useCallback(function (index) {
        setActiveTab(index);
        onChange(index);
    }, [setActiveTab, onChange]);
    var tabClickHandlers = React.useMemo(function () { return data === null || data === void 0 ? void 0 : data.map(function (_, tabIndex) { return function () { return handleClick(tabIndex); }; }); }, [data, handleClick]);
    React.useEffect(function () {
        if (Number.isInteger(activeTab)) {
            setActiveTab(activeTab);
        }
    }, [activeTab]);
    var lineIndent = orientation === 'vertical'
        ? (active * (tabSize + verticalTabBottomMargin))
        : (active * tabSize);
    var isIconVariant = variant === 'icon';
    return (React__default.createElement(TabsContainer, null,
        React__default.createElement(StyledTabs, tslib_es6.__assign({ orientation: orientation, variant: variant }, restTabsProps, { className: className }), data === null || data === void 0 ? void 0 :
            data.map(function (tab$1, tabIndex) { return (React__default.createElement(tab.Tab, { dataTestId: "tab-" + tabIndex, key: tab$1.label, onClick: tabClickHandlers === null || tabClickHandlers === void 0 ? void 0 : tabClickHandlers[tabIndex], variant: active === tabIndex ? 'active' : tab$1.variant, disabled: tab$1.disabled, orientation: orientation, lineWidth: lineWidth, tabSize: tabSize, verticalTabBottomMargin: verticalTabBottomMargin, isIconVariant: isIconVariant, icon: tab$1.icon }, tab$1.label)); }),
            children && React__default.Children.map(children, function (child, i) {
                var _a;
                return (React__default.cloneElement(child, {
                    dataTestId: "tab-" + i,
                    variant: active === i ? 'active' : (_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.variant,
                    onClick: function () { return handleClick(i); },
                    lineWidth: lineWidth,
                    tabSize: tabSize,
                    verticalTabBottomMargin: verticalTabBottomMargin,
                }));
            })),
        !themeUtils.isConsumerTheme(theme) && !isIconVariant && (React__default.createElement(line.Line, { className: "tabs-line", "data-testid": "tabs-line", indent: lineIndent, size: tabSize, lineWidth: lineWidth, orientation: orientation }))));
};
var tabs = styled.withTheme(Tabs);
var templateObject_1, templateObject_2;

var StepTabsContainer = styled__default.div(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  gap:  ", ";\n"], ["\n  display: flex;\n  gap:  ", ";\n"])), function (_a) {
    var hasGaps = _a.hasGaps;
    return (hasGaps && '24px');
});
var HeaderSpan = styled__default.span(templateObject_2$1 || (templateObject_2$1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var StyledIcon = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  margin-right: 6px;\n  background-color: ", ";\n  color: ", ";\n  font-size: 12px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n"], ["\n  width: 20px;\n  height: 20px;\n  margin-right: 6px;\n  background-color: ", ";\n  color: ", ";\n  font-size: 12px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n"])), function (_a) {
    var background = _a.background;
    return background;
}, function (_a) {
    var color = _a.color;
    return color;
});
var StyledTab = styled__default.button(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  border: 0;\n  padding: 4px;\n  border-radius: 4px;\n  width: ", ";\n  font: 14px/22px ", ";\n  color: ", ";\n  background-color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  transition: background-color 0.3ms ease-out;\n  ", ";\n\n  &:hover {\n    ", ";\n  }\n"], ["\n  border: 0;\n  padding: 4px;\n  border-radius: 4px;\n  width: ", ";\n  font: 14px/22px ", ";\n  color: ", ";\n  background-color: ", ";\n  font-weight: ", ";\n  font-size: ", ";\n  transition: background-color 0.3ms ease-out;\n  ", ";\n\n  &:hover {\n    ",
    ";\n  }\n"])), function (_a) {
    var tabSize = _a.tabSize;
    return (tabSize ? tabSize + "px" : 'auto');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme, variant = _a.variant;
    return (variant === 'active' ? theme.colors.primary : theme.colors.greys.adminGreyDark);
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.transparent;
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'active' ? 500 : 400);
}, function (_a) {
    var variant = _a.variant;
    return (variant === 'active' ? '16px' : '14px');
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled && 'pointer-events: none');
}, function (_a) {
    var theme = _a.theme, isCompleted = _a.isCompleted, disabled = _a.disabled;
    return (!disabled && "\n      background-color: " + theme.colors.greys.adminGreyLight + ";\n      font-weight: " + (isCompleted ? 500 : 400) + ";\n      cursor: pointer;\n\n      " + StyledIcon + " {\n        background-color: " + (!isCompleted && theme.colors.greys.adminGreyMedium) + ";\n      }\n    ");
});
var templateObject_1$1, templateObject_2$1, templateObject_3, templateObject_4;

exports.HeaderSpan = HeaderSpan;
exports.StepTabsContainer = StepTabsContainer;
exports.StyledIcon = StyledIcon;
exports.StyledTab = StyledTab;
exports.tabs = tabs;
